<template>
    <div>
      <HeaderComponent :pageContent="pageHeader" @change_language="handleHeaderClick" />
  
      <div class="container py-4">
        <div class="row">
          <div class="col-md-7">
            <h2 class="fw-bold mb-2 colorText">Tech Integration Tools</h2>
            <hr class="hr" />
          </div>
  
          <div class="col-md-12">
            <p class="colorText mb-4">
              Enhance classroom engagement with digital tools that make learning interactive, collaborative, and
              student-centered. These platforms empower educators to transform lessons into dynamic experiences using
              video, real-time feedback, and creative expression.
            </p>
          </div>
        </div>
  
        <div class="row justify-content-center g-4">
          <!-- Card 1: Nearpod -->
          <div class="col-md-3 col-sm-6">
            <div class="tool-card shadow-sm">
              <div>
                <div class="tool-img-wrapper mx-auto mb-2">
                 <a href="https://nearpod.com/" target="_blank"> <img src="/assets/images/tech-integration/1.png" alt="Nearpod" /></a>
                </div>
                <h6 class="fw-bold mb-2 tool-title">Nearpod</h6>
                <p class="small colorText mb-3">
                  Create interactive lessons with videos, quizzes, and real-time feedback.
                </p>
              </div>
              <a href="https://nearpod.com/" target="_blank" class="btn btn-see-site mt-auto">See Site</a>
            </div>
          </div>
  
          <!-- Card 2: Pear Deck -->
          <div class="col-md-3 col-sm-6">
            <div class="tool-card shadow-sm">
              <div>
                <div class="tool-img-wrapper mx-auto mb-2">
                  <a href="https://www.peardeck.com/" target="_blank"><img src="/assets/images/tech-integration/2.png" alt="Pear Deck" /></a>
                </div>
                <h6 class="fw-bold mb-2 tool-title">Pear Deck</h6>
                <p class="small colorText mb-3">
                  Add interactive elements to Google Slides to boost student engagement.
                </p>
              </div>
              <a href="https://www.peardeck.com/" target="_blank" class="btn btn-see-site mt-auto">See Site</a>
            </div>
          </div>
  
          <!-- Card 3: Flip -->
          <div class="col-md-3 col-sm-6">
            <div class="tool-card shadow-sm">
              <div>
                <div class="tool-img-wrapper mx-auto mb-2">
                  <a href="https://itsflip.com/" target="_blank"><img src="/assets/images/tech-integration/3.png" alt="Flip" /></a>
                </div>
                <h6 class="fw-bold mb-2 tool-title">Flip</h6>
                <p class="small colorText mb-3">
                  Empower students to share their voices through short, video-based discussions.
                </p>
              </div>
              <a href="https://itsflip.com/" target="_blank" class="btn btn-see-site mt-auto">See Site</a>
            </div>
          </div>
  
          <!-- Card 4: Whiteboard.chat -->
          <div class="col-md-3 col-sm-6">
            <div class="tool-card shadow-sm">
              <div>
                <div class="tool-img-wrapper mx-auto mb-2">
                  <a href="https://www.whiteboard.chat/" target="_blank"><img src="/assets/images/tech-integration/4.png" alt="Whiteboard.chat" /></a>
                </div>
                <h6 class="fw-bold mb-2 tool-title">Whiteboard.chat</h6>
                <p class="small colorText mb-3">
                  Host live collaborative whiteboards with real-time tools for math, drawing, and teaching.
                </p>
              </div>
              <a href="https://www.whiteboard.chat/" target="_blank" class="btn btn-see-site mt-auto">See Site</a>
            </div>
          </div>
        </div>
      </div>
      <br><br><br>
      <br><br><br>
      <br><br><br>
      <br><br><br>
      <FooterComponent :pageContent="pageFooter" />
    </div>
  </template>
  
  <style>
  .colorText {
    color: #0c27bd;
  }
  
  .hr {
    border: 1px solid #0d6efd;
    border-radius: 5px;
  }
  
  .tool-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #007bff;
    color: #0c27bd;
    border-radius: 12px;
    background-color: #fff;
    height: 100%;
    padding: 1rem;
    text-align: center;
  }
  
  .tool-img-wrapper {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    border: 3px solid gold;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
  }
  
  .tool-img-wrapper img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: contain;
  }
  
  .tool-title {
    color: #0c27bd;
  }
  
  .btn-see-site {
    background-color: #1e90ff;
    color: white;
    font-weight: 600;
    border-radius: 8px;
    padding: 6px 16px;
    font-size: 0.9rem;
    border: none;
    transition: 0.2s;
  }
  
  .btn-see-site:hover {
    background-color: #0056b3;
  }
  </style>
  
  <script>
  import HeaderComponent from "@/components/HeaderComponent.vue";
  import FooterComponent from "@/components/FooterComponent.vue";
  import globalMixins from "@/plugins/globalMixins";
  
  export default {
    name: "tech-integration",
    components: {
      HeaderComponent,
      FooterComponent,
    },
    data() {
      return {
        pageContent: [],
        pageHeader: [],
        pageFooter: [],
      };
    },
    mounted() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }
      this.convertLanguage();
    },
    methods: {
      openModal(url) {
        console.log(url);
        this.videoUrl = url;
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
        this.videoUrl = "";
      },
      handleHeaderClick() {
        this.convertLanguage();
      },
      async convertLanguage() {
        const storedLanguage = localStorage.getItem("language");
        if (storedLanguage) {
          this.language = storedLanguage;
        }
  
        let lang = this.language;
        if (lang === "us") {
          lang = "en";
        }
  
        console.log("Updated content:", lang);
  
        const converted = globalMixins.class_room[lang];
        const pageHeader = globalMixins.pageHeader[lang];
        const pageFooter = globalMixins.pageFooter[lang];
  
        if (converted) {
          this.pageContent = {
            ...this.pageContent,
            ...converted,
          };
          this.pageHeader = {
            ...this.pageHeader,
            ...pageHeader,
          };
          this.pageFooter = {
            ...this.pageFooter,
            ...pageFooter,
          };
        }
      },
    },
  };
  </script>
  